import { palette } from '../global/palette';
import { typography } from '../global/typography';
import type { ComponentOverride } from '../types';

export const MuiListItemButton: ComponentOverride<'MuiListItemButton'> = {
  MuiListItemButton: {
    styleOverrides: {
      root: {
        ...typography.subtitle2,
        borderRadius: 6,
        paddingTop: 11,
        paddingBottom: 11,
        height: 40,
        '&:focus-visible, &:hover': {
          backgroundColor: palette.grey[300],
        },
        '&.Mui-selected': {
          backgroundColor: palette.primary.light,
          color: palette.common.white,
          '&:focus-visible, &:hover': {
            backgroundColor: palette.grey[300],
            color: palette.common.black,
            '& .MuiListItemIcon-root': {
              '& > svg': {
                fill: palette.common.black,
              },
            },
          },
          '& .MuiListItemIcon-root': {
            '& > svg': {
              fill: palette.common.white,
            },
          },
        },
      },
    },
  },
};
